function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Ribbon, Card, Empty, Search, Pending } from "../../components/analytics-kit";
import PlunkDropDown from "../../components/plunk-dropdown";
import ServiceFactory from "../../service";
import { fetchSales, comparisonQs, deltaOfPaced } from "../sales/territory-common";
import { count, dollars, money, countShort, pctChange, Change, displayTitle, catLabel, Thumb, Menu, askPlunk, seedLookAlike } from "./px-common";

/*
 * Product Explorer → Products tab (mockup productsflow/Main.dc.html).
 *
 * Primary source: GET /v1/sales/explorer/products/{range} (server paging, sort,
 * search, category). Fail-soft: when that endpoint errors (not deployed yet) the
 * tab falls back to the sources the page used before — /sales/products rows,
 * product_performance_stats views + forecast units, /sales/totals and the
 * 12-month /sales/forecast — and pages/sorts/searches those client-side.
 */

const PAGE = 50;
const SORTS = [["revenue", "Sort: Revenue"], ["units", "Sort: Units"], ["dealers", "Sort: Dealers"], ["views", "Sort: Website views"], ["price", "Sort: Avg price"], ["forecast", "Sort: Next 12 months"], ["name", "Sort: Name"]];
const STAT_RANGES = ["today", "yesterday", "this_week", "last_week", "last_7_days", "this_month", "last_month", "this_quarter", "last_quarter", "this_year", "last_year", "all_time"];
function svcGet(api) {
  return new (ServiceFactory.getType(api, "product"))().getAsync();
}
const N = v => Number(v) || 0;
function legacySortVal(r, sort) {
  switch (sort) {
    case "units":
      return N(r.units);
    case "dealers":
      return N(r.dealers);
    case "views":
      return N(r.views);
    case "price":
      return N(r.avgPrice);
    case "forecast":
      return N(r.forecastRevenue12) || N(r.forecastUnits12);
    default:
      return N(r.revenue);
  }
}
export default class ProductsList extends React.Component {
  constructor(props) {
    super(props);
    // ── Controls ──
    _defineProperty(this, "setSort", sort => this.setState({
      sort
    }, () => this.refresh()));
    _defineProperty(this, "setCategory", category => {
      if (category === this.state.category) return;
      // Category is server-side in both modes → full reload.
      this.setState({
        category,
        rows: null,
        totals: null
      }, () => this.load());
    });
    _defineProperty(this, "setQ", q => {
      this.setState({
        q
      });
      clearTimeout(this._qTimer);
      this._qTimer = setTimeout(() => {
        if (this._alive) this.refresh();
      }, 350);
    });
    _defineProperty(this, "loadMore", async () => {
      const {
        rows,
        mode
      } = this.state;
      if (mode === "legacy") {
        this.applyLegacy(rows.length + PAGE);
        return;
      }
      const seq = this._seq;
      this.setState({
        loadingMore: true
      });
      try {
        const res = await fetchSales(this.explorerUrl(rows.length));
        if (!this._alive || seq !== this._seq) return;
        this.setState({
          rows: rows.concat(res && res.rows || []),
          total: N(res && res.total) || this.state.total,
          loadingMore: false
        });
      } catch (e) {
        if (this._alive) this.setState({
          loadingMore: false
        });
      }
    });
    // ── Navigation ──
    _defineProperty(this, "openProduct", r => this.props.history.push({
      pathname: `/Products/${this.props.range}/product/${encodeURIComponent(r.productId)}`,
      state: r.title ? {
        title: r.title
      } : undefined
    }));
    _defineProperty(this, "openSeries", r => r.family && this.props.history.push(`/Products/${this.props.range}/family/${encodeURIComponent(r.family)}`));
    _defineProperty(this, "ask", r => {
      const name = [r.sku || r.productId, displayTitle(r.title)].filter(Boolean).join(" ");
      askPlunk(`Tell me about ${name}: how it is selling, which ${this.props.dealerWord.toLowerCase()} buy it, what people look at on the website, and what the next 12 months look like.`);
    });
    this.state = {
      rows: null,
      total: 0,
      totals: null,
      mode: null,
      error: false,
      sort: "revenue",
      q: "",
      category: props.initialCategory || "",
      loadingMore: false,
      cmp: null,
      legacyAll: null
    };
    this._alive = true;
    this._seq = 0;
    this._qTimer = null;
  }
  componentDidMount() {
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
    clearTimeout(this._qTimer);
  }
  componentDidUpdate(prev) {
    if (prev.range !== this.props.range || prev.statusKey !== this.props.statusKey || prev.acctKv !== this.props.acctKv || prev.comp !== this.props.comp) {
      this.setState({
        rows: null,
        totals: null,
        cmp: null,
        error: false
      }, () => this.load());
    }
  }

  // Shared query fragments (status + account lens) for every /v1/sales call.
  filterKv() {
    const kv = [];
    if (this.props.statusKey) kv.push(`status=${encodeURIComponent(this.props.statusKey)}`);
    if (this.props.acctKv) kv.push(this.props.acctKv);
    return kv;
  }
  async load() {
    const seq = ++this._seq;
    const range = this.props.range;
    const kv = this.filterKv();
    const cmpQs = comparisonQs(range, true, this.props.comp);
    const cmpUrl = `/sales/totals/${range}${cmpQs}${cmpQs ? kv.length ? "&" + kv.join("&") : "" : kv.length ? "?" + kv.join("&") : ""}`;
    const cmpP = fetchSales(cmpUrl).catch(() => null);
    try {
      const res = await fetchSales(this.explorerUrl(0));
      if (!res || !Array.isArray(res.rows)) throw new Error("explorer shape");
      const cmp = await cmpP;
      if (!this._alive || seq !== this._seq) return;
      this.setState({
        mode: "explorer",
        rows: res.rows,
        total: N(res.total),
        totals: res.totals || {},
        cmp,
        error: false
      });
      if (this.props.onTotals) this.props.onTotals(res.totals || null);
    } catch (e) {
      await this.loadLegacy(seq, cmpP);
    }
  }
  explorerUrl(skip) {
    const {
      sort,
      q,
      category
    } = this.state;
    const kv = this.filterKv();
    if (category) kv.push(`category=${encodeURIComponent(category)}`);
    if (q.trim()) kv.push(`q=${encodeURIComponent(q.trim())}`);
    kv.push(`sort=${sort}`, `dir=${sort === "name" ? "asc" : "desc"}`, `top=${PAGE}`, `skip=${skip}`);
    return `/sales/explorer/products/${this.props.range}?${kv.join("&")}`;
  }

  // ── Fallback: the page's previous data sources ──
  async loadLegacy(seq, cmpP) {
    const range = this.props.range;
    const kv = this.filterKv();
    const {
      category
    } = this.state;
    const salesKv = kv.concat(category ? [`category=${encodeURIComponent(category)}`] : []);
    const acct = this.props.acctKv ? `&${this.props.acctKv}` : "";
    const statRange = STAT_RANGES.indexOf(range) >= 0 ? range : null;
    try {
      const [sales, stats, forecast, cmp] = await Promise.all([fetchSales(`/sales/products/${range}?top=500${salesKv.length ? "&" + salesKv.join("&") : ""}`).catch(() => []), statRange ? svcGet(`/product/performance/stats/${statRange}?$skip=0&$top=2000&$orderBy=${encodeURIComponent("views desc")}${category ? `&category=${encodeURIComponent(category)}` : ""}${acct}`).catch(() => ({
        items: [],
        count: 0
      })) : Promise.resolve({
        items: [],
        count: 0
      }), fetchSales(`/sales/forecast/${range}?months=12${acct}`).catch(() => []), cmpP]);
      if (!this._alive || seq !== this._seq) return;
      const items = stats && stats.items || [];
      const byId = {};
      items.forEach(s => {
        byId[String(s.productId)] = s;
      });
      const rows = (Array.isArray(sales) ? sales : []).map(s => {
        const st = byId[String(s.productId)] || {};
        const fu = st.lastForecastDate && N(st.forecastSalesQuantity) >= 0 ? N(st.forecastSalesQuantity) : null;
        return {
          productId: s.productId,
          sku: s.sku,
          title: s.title || st.title,
          imageLink: s.imageLink || st.imageLink,
          category: st.category || st.productType || null,
          family: null,
          revenue: N(s.totalAmount),
          units: N(s.quantity),
          orders: N(s.orders),
          dealers: N(s.customers),
          avgPrice: N(s.quantity) ? N(s.totalAmount) / N(s.quantity) : null,
          views: st.views != null ? N(st.views) : null,
          prevViews: null,
          forecastRevenue12: null,
          forecastUnits12: fu
        };
      });
      const c = cmp || {};
      const totals = {
        revenue: c.totalAmount != null ? N(c.totalAmount) : rows.reduce((a, r) => a + r.revenue, 0),
        units: c.quantity != null ? N(c.quantity) : rows.reduce((a, r) => a + r.units, 0),
        dealers: c.customers != null ? N(c.customers) : null,
        products: N(stats && stats.count) || rows.length,
        views: items.reduce((a, r) => a + N(r.views), 0),
        forecastRevenue12: (Array.isArray(forecast) ? forecast : []).filter(r => r.isForecast).reduce((a, r) => a + N(r.totalAmount), 0)
      };
      this.setState({
        mode: "legacy",
        legacyAll: rows,
        totals,
        cmp,
        error: false
      }, () => this.applyLegacy());
      if (this.props.onTotals) this.props.onTotals(totals);
    } catch (e) {
      if (this._alive && seq === this._seq) this.setState({
        error: true
      });
    }
  }
  legacyFiltered() {
    const {
      legacyAll,
      q,
      sort
    } = this.state;
    const term = q.trim().toLowerCase();
    let list = (legacyAll || []).filter(r => !term || String(r.title || "").toLowerCase().includes(term) || String(r.sku || r.productId || "").toLowerCase().includes(term));
    list = list.slice().sort((a, b) => sort === "name" ? displayTitle(a.title).localeCompare(displayTitle(b.title)) : legacySortVal(b, sort) - legacySortVal(a, sort));
    return list;
  }
  applyLegacy(n = PAGE) {
    const list = this.legacyFiltered();
    this.setState({
      rows: list.slice(0, n),
      total: list.length
    });
  }
  // Sort/search change: page 1 again (totals unchanged).
  async refresh() {
    if (this.state.mode === "legacy") {
      this.applyLegacy();
      return;
    }
    const seq = ++this._seq;
    this.setState({
      rows: null
    });
    try {
      const res = await fetchSales(this.explorerUrl(0));
      if (!this._alive || seq !== this._seq) return;
      this.setState({
        rows: res && res.rows || [],
        total: N(res && res.total)
      });
    } catch (e) {
      if (this._alive && seq === this._seq) this.setState({
        error: true
      });
    }
  }
  // ── Render ──
  renderRibbon() {
    const t = this.state.totals;
    if (!t) return /*#__PURE__*/React.createElement(Ribbon, {
      loading: true,
      tiles: []
    });
    const c = this.state.cmp || {};
    const range = this.props.range;
    const vs = this.props.comp === "prev_year" ? "vs last year" : "vs the previous period";
    const dl = (cur, prev) => {
      const d = deltaOfPaced(cur, prev, range);
      if (!d) return "";
      const r = Math.round(d.pct);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: `px-chg ${r > 0 ? "up" : r < 0 ? "down" : "flat"}`
      }, r > 0 ? "+" : r < 0 ? "−" : "", Math.abs(r), "%"), " ", vs);
    };
    const dealers = t.dealers != null ? N(t.dealers) : c.customers != null ? N(c.customers) : null;
    const tiles = [
    // The change compares like with like: both periods from the same totals call
    // (the explorer totals leave out fabric, freight and samples; the totals call doesn't).
    {
      l: "Revenue",
      v: money(t.revenue),
      s: c.prevTotalAmount ? dl(c.totalAmount, c.prevTotalAmount) : ""
    }, {
      l: "Units sold",
      v: count(t.units),
      s: c.prevQuantity ? dl(c.quantity, c.prevQuantity) : ""
    }, {
      l: "Products sold",
      v: count(t.products),
      s: dealers != null ? `to ${count(dealers)} ${this.props.dealerWord.toLowerCase()}` : ""
    }, {
      l: "Product page views",
      v: countShort(t.views),
      s: "on your website"
    }, {
      l: "Next 12 months",
      v: N(t.forecastRevenue12) ? money(t.forecastRevenue12) : "—",
      s: "expected revenue"
    }];
    return /*#__PURE__*/React.createElement(Ribbon, {
      comparing: null,
      tiles: tiles
    });
  }
  renderChips() {
    const cats = (this.props.categories || []).filter(c => c && c.category);
    const {
      category
    } = this.state;
    const top = cats.slice(0, 6);
    const rest = cats.slice(6);
    const selectedInRest = category && !top.some(c => c.category === category);
    const selRow = selectedInRest ? cats.find(c => c.category === category) : null;
    return /*#__PURE__*/React.createElement("span", {
      className: "px-chips"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "px-chip" + (!category ? " on" : ""),
      onClick: () => this.setCategory("")
    }, "All"), top.map(c => /*#__PURE__*/React.createElement("button", {
      type: "button",
      key: c.category,
      className: "px-chip" + (category === c.category ? " on" : ""),
      onClick: () => this.setCategory(c.category)
    }, catLabel(c.category))), selectedInRest ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "px-chip on",
      onClick: () => this.setCategory("")
    }, catLabel(selRow ? selRow.category : category)) : null, rest.length ? /*#__PURE__*/React.createElement(Menu, {
      label: "More categories",
      align: "left",
      triggerCls: "px-chip",
      trigger: "More \u25BE",
      items: rest.map(c => ({
        key: c.category,
        label: catLabel(c.category),
        on: c.category === category,
        onClick: () => this.setCategory(c.category)
      }))
    }) : null);
  }
  footNote() {
    const st = this.props.statusKey;
    const first = st ? `Counts orders with the selected order types (${st.split(",").join(", ")}), the same filter as the Series tab.` : "Counts every booked order for your products, the same as the Series tab. Fabric sold by the yard, freight and samples are left out.";
    const fc = this.state.mode === "legacy" ? "Next 12 months shows the units from each product's forecast." : "Next 12 months projects each product's average month over the last six months.";
    return `${first} Avg price sold is revenue divided by units. ${fc}`;
  }
  renderRow(r) {
    const title = displayTitle(r.title);
    const code = r.sku || (/^shopify:/i.test(String(r.productId || "")) ? "" : r.productId);
    const head = [code, title].filter(Boolean).join(" · ") || String(r.productId);
    const sub = [r.category ? catLabel(r.category) : null, r.family && !this.props.seriesHidden ? `Series ${r.family}` : null].filter(Boolean).join(" · ");
    const avg = r.avgPrice != null ? N(r.avgPrice) : N(r.units) ? N(r.revenue) / N(r.units) : 0;
    const fRev = N(r.forecastRevenue12),
      fUnits = r.forecastUnits12 != null ? N(r.forecastUnits12) : null;
    const fc = fRev || fUnits ? [fRev ? money(fRev) : null, fUnits != null ? `${count(fUnits)} units` : null].filter(Boolean).join(" · ") : null;
    return /*#__PURE__*/React.createElement("tr", {
      key: r.productId,
      className: "clickable",
      onClick: () => this.openProduct(r),
      title: `Open ${title || code}`
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: "px-ident"
    }, /*#__PURE__*/React.createElement(Thumb, {
      src: r.imageLink
    }), /*#__PURE__*/React.createElement("span", {
      className: "px-ident-txt"
    }, /*#__PURE__*/React.createElement("span", {
      className: "px-name"
    }, head), sub ? /*#__PURE__*/React.createElement("span", {
      className: "px-sub"
    }, sub) : null))), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, avg ? dollars(avg) : "—"), /*#__PURE__*/React.createElement("td", {
      className: "n strong"
    }, dollars(r.revenue)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, count(r.units)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, count(r.dealers)), /*#__PURE__*/React.createElement("td", {
      className: "px-views"
    }, r.views != null ? /*#__PURE__*/React.createElement(React.Fragment, null, count(r.views), " ", /*#__PURE__*/React.createElement(Change, {
      c: pctChange(r.views, r.prevViews)
    })) : /*#__PURE__*/React.createElement("span", {
      className: "px-muted"
    }, "\u2014")), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, fc || /*#__PURE__*/React.createElement("span", {
      className: "px-muted",
      title: "Needs a couple of months of sales history to forecast."
    }, "\u2014")), /*#__PURE__*/React.createElement("td", {
      className: "px-act"
    }, /*#__PURE__*/React.createElement(Menu, {
      label: `More for ${head}`,
      items: [{
        label: "Open product",
        onClick: () => this.openProduct(r)
      }, r.family && !this.props.seriesHidden ? {
        label: "Open its series",
        onClick: () => this.openSeries(r)
      } : null, r.imageLink ? {
        label: "Forecast a look-alike",
        onClick: () => seedLookAlike(r, this.props.history)
      } : null, {
        label: "Ask about this product",
        onClick: () => this.ask(r)
      }]
    })));
  }
  render() {
    const {
      rows,
      total,
      error,
      sort,
      q,
      loadingMore
    } = this.state;
    const dw = this.props.dealerWord;
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderRibbon(), /*#__PURE__*/React.createElement(Card, {
      cls: "px-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "px-toolbar"
    }, this.renderChips(), /*#__PURE__*/React.createElement("span", {
      className: "px-tools"
    }, /*#__PURE__*/React.createElement(Search, {
      value: q,
      onChange: this.setQ,
      placeholder: "Search by name or SKU"
    }), /*#__PURE__*/React.createElement(PlunkDropDown, {
      options: SORTS,
      value: sort,
      onChange: this.setSort,
      width: "200px"
    }))), error ? /*#__PURE__*/React.createElement(Empty, null, "The products couldn't be loaded. Try again in a minute.") : !rows ? /*#__PURE__*/React.createElement(Pending, {
      h: 320
    }) : !rows.length ? /*#__PURE__*/React.createElement(Empty, null, q ? `No products match "${q}".` : "No products sold in this period.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table px-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Product"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Avg price sold"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Revenue"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Units"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, dw), /*#__PURE__*/React.createElement("th", null, "Website views"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Next 12 months"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, rows.map(r => this.renderRow(r)))))), /*#__PURE__*/React.createElement("div", {
      className: "px-foot"
    }, /*#__PURE__*/React.createElement("span", null, this.footNote()), rows && rows.length < total ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "px-more",
      disabled: loadingMore,
      onClick: this.loadMore
    }, loadingMore ? "Loading…" : "Show more products") : null)));
  }
}